/**
 * Pulizia dell'HTML incollato nelle comunicazioni e nelle circolari: carattere,
 * dimensione e interlinea sono quelli del sito e della mail, non si scelgono.
 * Toglie font-size, font-family e line-height dagli style inline, gli attributi
 * size e face e i tag <font> (ne tiene il contenuto). Grassetto, corsivo, elenchi,
 * link e colore restano.
 */
const PROPRIETA_CARATTERE = ['font-size', 'font-family', 'line-height'];

export function pulisciStiliCarattere(html: string): string {
  if (!html) return '';
  const contenitore = document.createElement('template');
  contenitore.innerHTML = html;
  const radice = contenitore.content;

  radice.querySelectorAll('font').forEach((font) => {
    font.replaceWith(...Array.from(font.childNodes));
  });

  radice.querySelectorAll('*').forEach((el) => {
    el.removeAttribute('size');
    el.removeAttribute('face');
    const stile = (el as HTMLElement).style;
    if (!stile || !el.hasAttribute('style')) return;
    PROPRIETA_CARATTERE.forEach((p) => stile.removeProperty(p));
    if (!stile.cssText.trim()) el.removeAttribute('style');
  });

  const uscita = document.createElement('div');
  uscita.appendChild(radice.cloneNode(true));
  return uscita.innerHTML;
}

/** Testo semplice degli appunti in HTML: escape e ritorni a capo come <br>. */
export function testoInHtml(testo: string): string {
  return testo
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\r?\n/g, '<br>');
}
